exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".flex{display:-ms-flexbox;display:flex}.flex.flex-row{-ms-flex-direction:row;flex-direction:row}.flex.flex-column{-ms-flex-direction:column;flex-direction:column}.flex.flex-wrap{-ms-flex-wrap:wrap;flex-wrap:wrap}.flex.flex-horizontal-justify{-ms-flex-pack:justify;justify-content:space-between}.flex.flex-horizontal-center{-ms-flex-pack:center;justify-content:center}.flex.flex-vertical-spread{-ms-flex-line-pack:distribute;align-content:space-around}.flex.flex-vertical-center{-ms-flex-align:center;align-items:center}.flex-item-half{margin:0 4%;width:42%}.flex-item-half-wide{margin:0 2%;width:46%}.flex-item-third{margin:0 4%;width:25.333333%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/components/components.styl
// module id = 160
// module chunks = 0 1